<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            append-to-body
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                :rules="dataRule"
                @keyup.enter.native="dataFormSubmit()"
                label-width="132px"
                style="display: flex;flex-wrap: wrap;justify-content: space-between"
        >
            <el-form-item label="字段名称：" prop="columnName">
                <el-input v-model="dataForm.columnName" placeholder="字段名称"></el-input>
            </el-form-item>
            <el-form-item label="显示名称：" prop="displayName">
                <el-input v-model="dataForm.displayName" placeholder="字段编码"></el-input>
            </el-form-item>
            <el-form-item label="字段类型：" prop="columnType">
                <el-select
                        v-model="dataForm.columnType"
                        placeholder="字段类型"
                        style="display: block; margin-bottom: 10px"
                        @change="colChange"
                >
                    <el-option
                            v-for="item in columnTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否展示：" prop="showInList">
                <el-select v-model="dataForm.showInList" placeholder="是否展示"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

           <el-form-item label="显示表达式：" v-if="dataForm.showInList">
             <el-input v-model="dataForm.showExp" placeholder="执行上下文字段表达式"></el-input>
            </el-form-item>

            <el-form-item label="是否展示显示名：" prop="textType">
                <el-select v-model="dataForm.textType" placeholder="是否展示显示名"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions2"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否为查询参数：" prop="isQueryParam">
              <el-select v-model="dataForm.isQueryParam" placeholder="是否为查询参数"
                         style="display: block;margin-bottom: 10px">
                <el-option
                    v-for="item in trueOrFalseOptions3"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-show="normalTxtMch(dataForm.columnType)" label="转换类型：" prop="desensitType">
                <el-select
                        v-model="dataForm.desensitType"
                        placeholder="转换类型"
                        clearable
                        style="display: block; margin-bottom: 10px">
                    <el-option
                            v-for="item in desensitTypeList"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="拼接前缀：" v-show="normalTxtMch(dataForm.columnType)">
                <el-input v-model="dataForm.prefix" placeholder="输入需要拼接的字段名称"></el-input>
            </el-form-item>
            <el-form-item label="拼接后缀：" v-show="normalTxtMch(dataForm.columnType)">
                <el-input v-model="dataForm.suffix" placeholder="输入需要拼接的字段名称"></el-input>
            </el-form-item>
          <el-form-item label="默认值：" v-show="normalTxtMch(dataForm.columnType)">
                <el-input v-model="dataForm.defaultValue" placeholder="输入默认值"></el-input>
            </el-form-item>
            <el-form-item label="数据源类型：" prop="datasetType" v-show="normalTxtMch(dataForm.columnType)">
                <el-select
                        v-model="dataForm.datasourceType"
                        placeholder="请选择数据源类型"
                        style="display: block; margin-bottom: 10px"
                        @change="datasrouceChg"
                >
                    <el-option
                            v-for="item in datasourceTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据格式：" v-show="dataForm.columnType==2">
                <el-input v-model="dataForm.patternRegex" placeholder="请输入数据格式"></el-input>
            </el-form-item>

           <el-form-item label="数据源：" prop="datasource" v-if="normalTxtMch(dataForm.columnType)">
                <el-input v-model="dataForm.datasource" :placeholder="placeholer"></el-input>
            </el-form-item>
          <el-form-item label="自定义表单选择：" v-if="dataForm.columnType==1||dataForm.columnType==4">
            <el-select
                v-model="extAttrs.formId"
                filterable
                placeholder="请选择自定义表单"
                style="display: block; margin-bottom: 10px"
            >
              <el-option
                  v-for="item in customList"
                  :key="item.id"
                  :label="item.tit"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="按钮名称：" v-if="dataForm.columnType==1">
            <el-input v-model="extAttrs.btnName" placeholder="请填写按钮名称"></el-input>
          </el-form-item>
          <el-form-item label="按钮图标：" v-if="dataForm.columnType==1">
            <el-input v-model="extAttrs.btnIcon" placeholder="请填写按钮图标"></el-input>
          </el-form-item>
          <el-form-item label="显示列表序号：" v-if="dataForm.columnType==4">
            <el-switch v-model="extAttrs.showSort" inactive-text="否" active-text="是" active-value="1" inactive-value="0"/>
          </el-form-item>
          <el-form-item label="显示过滤查询：" v-if="dataForm.columnType==4">
            <el-switch v-model="extAttrs.showFilter" inactive-text="否" active-text="是" :active-value="true" :inactive-value="false"/>
          </el-form-item>
          <el-form-item label="显示分页：" v-if="dataForm.columnType==4">
            <el-tooltip content="建议开启，否则页面渲染表格方式不会采用异步查询数据" placement="top">
              <span class="el-icon-warning-outline"></span>
            </el-tooltip>
            <el-switch v-model="extAttrs.showPage" inactive-text="否" active-text="是" :active-value="true" :inactive-value="false"/>
          </el-form-item>
          <el-form-item label="显示操作：" v-if="dataForm.columnType==4">
            <el-switch v-model="extAttrs.showOpt" inactive-text="否" active-text="是" :active-value="true" :inactive-value="false"/>
          </el-form-item>
          <el-form-item label="是否动态请求：" v-if="dataForm.columnType==7">
            <el-switch v-model="extAttrs.dynamic" inactive-text="否" active-text="是" :active-value="true" :inactive-value="false"/>
          </el-form-item>
          <el-form-item label="请求路径：" v-if="dataForm.columnType==7||dataForm.columnType==5||dataForm.columnType==6">
            <el-input v-model="extAttrs.url" placeholder="请填写请求路径"></el-input>
          </el-form-item>

          <el-form-item label="附件类型编码：" v-if="dataForm.columnType==8">
            <el-input v-model="extAttrs.atttype" placeholder="请填写附件类型编码"></el-input>
          </el-form-item>
          <el-form-item label="附件类型集：" v-if="dataForm.columnType==8">
            <el-input v-model="extAttrs.types" placeholder="请填写附件类型,逗号分隔"></el-input>
          </el-form-item>
            <br>
            <el-form-item label="列数：" prop="columnCount">
                <el-select v-model="dataForm.columnCount" placeholder="列数"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in columnCountOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="列宽：" prop="columnWidth">
                <el-input
                        v-model="dataForm.columnWidth"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input
                        v-model="dataForm.sort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
            <el-form-item label="跨列名称：">
                <el-input v-model="dataForm.colspan"></el-input>
            </el-form-item>
            <el-form-item label="前端样式：">
                <el-input v-model="dataForm.style" placeholder="填写css行内样式"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import axios from "axios";
    import {
        apiCustomformFromdatasetfieldGet,
        apiCustomformFromdatasetfieldGetDesensitizatType,
        apiCustomformFromdatasetfieldSave,
        apiCustomformGetEnumList,
        apiSysDictDataGetList
    } from "../../server/formConfig";
    import {parseSource} from "../../utils/utils";

    const defaultForm = {
        id: "",
        formId: "",
        desensitType:'',
        columnName:"",
        textType:1,
        displayName:"",
        columnType:'2',
        showInList:true,
        required:"",
        datasource:"",
        datasetId:"",
        datasourceType:"",
        patternRegex:"",
        columnCount:'2',
        columnWidth:"",
        showExp:"",
        showLength:'50',
        prefix:"",
        suffix:"",
        defaultValue:"",
        singleRadio:"",
        isQueryParam:"",
        sort: 10,
    }
    export default {
        props: ["mainContentViewHeight"],
        data() {
            return {
                visible: false,
                datasourceTypeList: [],
                columnTypeList:[],
                desensitTypeList:[],
                customList: [],
                specialTypes:['1','4','5','6','7','8','99'],
                nomarlTxtMatchs:["2","99"],
                dataForm: defaultForm,
                placeholer:"请输入数据源",
                extAttrs:{},
                columnCountOptions: [{'text': '单列(整行)', 'value': '1'}, {'text': '两列', 'value': '2'}, {'text': '三列', 'value':'3'}],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                trueOrFalseOptions2: [{'text': '否', 'value': 0}, {'text': '是', 'value': 1}],
                trueOrFalseOptions3: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                radioOrCheckOptions: [{'text': '单选', 'value': '1'}, {'text': '多选', 'value': '2'}],
                dataRule: {
                    columnName: [
                        {required: true, message: '字段名不能为空', trigger: 'blur'},
                    ],
                    showInList: [
                        {required: true, message: '是否展示不能为空', trigger: 'blur'},
                    ],
                    displayName: [
                        {required: true, message: '显示名不能为空', trigger: 'blur'},
                    ],

                }
            };
        },
        created() {
            this.initSelectData();
            this.getDicData();
            this.getDic('field_render_type');
        },
        methods: {
            init(id,fromId, groupId,customs) {
                this.dataForm.id = id || "";
                this.dataForm.formId = fromId || "";
                this.dataForm.groupId = groupId || '';
                this.customList=customs||[]
                this.visible = true;
                this.extAttrs= {};
                if (this.dataForm.id) {
                    apiCustomformFromdatasetfieldGet(this.dataForm.id).then(({data}) => {
                        if (data && data.code === "1") {
                            this.dataForm = {...data.data};
                            this.dataForm.columnType = data.data.columnType;
                            this.extAttrs=null
                            if (this.specialTypes.indexOf(this.dataForm.columnType)!=-1){
                                this.extAttrs=parseSource(this.dataForm.datasource||'{}')
                            }
                            this.dataForm.showLength = data.data.showLength?data.data.showLength:'50';
                            this.dataForm.columnCount = data.data.columnCount?data.data.columnCount:'1';
                            this.dataForm.singleRadio = data.data.singleRadio?data.data.singleRadio:'1';
                            this.dataForm.desensitType = data.data.desensitType == 0?'':data.data.desensitType
                        } else {
                            this.dataForm = defaultForm;
                        }
                    });
                }
            },
          colChange(n,o){
            if (this.specialTypes.indexOf(this.dataForm.columnType)!=-1){
              var col=this.dataForm.columnName;
              if (col.indexOf('#')<0){
                col+='#'+parseInt(Math.random()*1000)
                this.dataForm.columnName=col;
              }
              this.extAttrs={}
            }else{
              this.extAttrs=null
            }
          },
          normalTxtMch(type){
              return this.nomarlTxtMatchs.indexOf(type)!=-1
          },
            datasrouceChg(n){
              switch (n){
                case '1':
                  this.placeholer="请输入上级区域编码";
                  break;
                case '2':
                   this.placeholer="请输入数据字典类型编码";
                   break;
                case '0':
                   this.placeholer="";
                   break;
              }
            },

            getDicData(){
                apiCustomformFromdatasetfieldGetDesensitizatType().then(res => {
                    if (res.data.code === '1') {
                        this.desensitTypeList = res.data.data
                    }else{
                        this.desensitTypeList = [];
                    }
                })

            },
            getDic(type) { // 获取字典
                apiSysDictDataGetList(type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'field_render_type':this.columnTypeList = res.data.data;break;
                        }
                    }
                })
            },
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL: '',
                };
                ops = Object.assign(ops, extOps);
                return this.$http(ops);
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            initSelectData() {
                let _self = this;
                apiCustomformGetEnumList(0).then(({data}) => {
                    let result = []
                    for (var i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (item.id == 4 || item.id == 5 || item.id == 6) {
                            continue
                        }
                        result.push(item)
                    }
                    _self.datasourceTypeList = _self.transformToInt(result);
                })
            },
            // 表单提交
            dataFormSubmit() {
                if (this.dataForm.formId == undefined) {
                    this.$message.error('自定义表单无效');
                    return;
                }
                if (this.extAttrs){
                  this.dataForm.datasource=JSON.stringify(this.extAttrs);
                }
                //新增数据时做处理
                if (this.dataForm.id==""&&this.dataForm.datasetId==""){
                  this.dataForm.datasetId="1";
                }
                apiCustomformFromdatasetfieldSave(this.dataForm).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .el-form /deep/ .el-form-item {
        width: 50%;
    }

    .el-dialog__wrapper /deep/ .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
